






import { State, Getter } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Error: () => import('./Error.vue'),
  },
})
export default class ElServerError extends Vue {
  @Getter('getErrors') serverError!: ErrorResponse;
}
